<template>
  <b-card class="mb-2">
    <b-card-text>
      <h4 class="text-muted">{{client.name}}</h4>
      <div v-for="(product, idx) in client.productPrices" :key="idx">
        <b-row>
          <b-col sm="6">
            <p class="mb-1">
              {{ products[product.id].name }} -
              <b-badge variant="primary">{{ product.price }} €</b-badge>
            </p>
          </b-col>
          <b-col sm="6" class="mb-1">
            <b-form-group :id="`quantity-product-${idx}`">
              <b-form-input
                v-model="prevision[idx]"
                trim
                placeholder="Cantidad"
                @input="onChangePrevision($event, product.id)"/>
            </b-form-group>
          </b-col>
        </b-row>
      </div>
    </b-card-text>
  </b-card>
</template>

<script>
export default {
  props: {
    client: { type: Object, required: true },
    products: { type: Object, required: true }
  },
  data () {
    return {
      prevision: {
        clientId: this.client.id
      }
    }
  },
  methods: {
    onChangePrevision (val, productId) {
      const prevision = {
        clientId: this.client.id,
        productId,
        quantity: val
      }
      this.$emit('onPrevisionUpdate', prevision)
    }
  }
}
</script>
